var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Fetcher {
    constructor() {
        this.handlers = {};
        this.register("http", {
            fetchText: (url) => __awaiter(this, void 0, void 0, function* () { return yield (yield fetch(url)).text(); }),
        });
        this.register("https", {
            fetchText: (url) => __awaiter(this, void 0, void 0, function* () { return yield (yield fetch(url)).text(); }),
        });
    }
    findHandler(url) {
        const scheme = url.protocol.slice(0, url.protocol.length - 1);
        return this.handlers[scheme];
    }
    formatURL(url) {
        const handler = this.findHandler(url);
        if (handler === undefined) {
            throw new Error([
                `[Fetcher.formatURL] I meet unknown protocol.`,
                ``,
                `  protocol: ${url.protocol}`,
                `  url: ${url.href}`,
            ].join("\n"));
        }
        if (handler.formatURL) {
            return handler.formatURL(url);
        }
        else {
            return url.href;
        }
    }
    fetchText(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const handler = this.findHandler(url);
            if (handler === undefined) {
                throw new Error([
                    `[Fetcher.fetchText] I meet unknown protocol.`,
                    ``,
                    `  protocol: ${url.protocol}`,
                    `  url: ${url.href}`,
                ].join("\n"));
            }
            return handler.fetchText(url);
        });
    }
    register(scheme, handler) {
        this.handlers[scheme] = handler;
    }
}
//# sourceMappingURL=Fetcher.js.map